import axios from 'axios'

function readCsrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
}

function updateCsrfToken(token) {
  if (!token) return

  const meta = document.querySelector('meta[name="csrf-token"]')
  if (meta) {
    meta.setAttribute('content', token)
  }
}

const client = axios.create({
  headers: {
    Accept: 'application/json',
  },
  withCredentials: true,
  xsrfCookieName: undefined,
})

client.interceptors.request.use((config) => {
  const token = readCsrfToken()
  if (token) {
    config.headers['X-CSRF-Token'] = token

    if (config.data instanceof FormData && !config.data.has('authenticity_token')) {
      config.data.append('authenticity_token', token)
    }
  }
  return config
})

client.interceptors.response.use(
  (response) => {
    updateCsrfToken(response.headers['x-csrf-token'])
    return response
  },
  (error) => {
    updateCsrfToken(error.response?.headers['x-csrf-token'])
    return Promise.reject(error)
  }
)

export default client
